import { createFileRoute } from '@tanstack/react-router';
import { gql, useQuery } from '@apollo/client';
import { FeedInfiniteScroll } from '../../../../components/by-type/feed/generic-feed-infinite-scroll';
import { FeedItemOrderBy, FeedItemType } from 'shared/__generated__/graphql';

type RecommendationViewProps = {
  username: string;
};

type Inputs = {
  orderBy: 'oldestFirst' | 'newestFirst';
};

const PAGE_LENGTH = 20;
export const Route = createFileRoute('/u/$username/feed/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { username } = Route.useParams();

  const { data } = useQuery(
    gql/* GraphQL */ `
      query getProfileUserId($username: String!) {
        user(username: $username) {
          id
        }
      }
    `,
    {
      variables: {
        username,
      },
    },
  );

  return (
    <div className="flex w-full justify-center pt-[48px]">
      <div className="flex flex-col gap-6 w-[700px] max-w-full overflow-x-hidden transition-all duration-300">
        {data?.user?.id && (
          <FeedInfiniteScroll
            key="allRecs"
            onlyFollowing={false}
            originUserId={data?.user?.id}
            forceTypes={[FeedItemType.NewUser]}
            includeOriginUsername={false}
            shouldDebounceVariables
            enabledOrderByOptions={[
              FeedItemOrderBy.NewestFirst,
              FeedItemOrderBy.Random,
              FeedItemOrderBy.TopOfDay,
              FeedItemOrderBy.TopOfWeek,
              FeedItemOrderBy.TopOfMonth,
              FeedItemOrderBy.TopOfYear,
              FeedItemOrderBy.TopOfAllTime,
            ]}
            enabledFeedItemTypes={[
              FeedItemType.AddRecommendation,
              FeedItemType.NewPrompt,
              FeedItemType.NewUser,
              FeedItemType.NewUserFollow,
              FeedItemType.NewRePost,
              FeedItemType.NewRePostWithContent,
              FeedItemType.NewPromptRecReply,
              FeedItemType.NewComment,
            ]}
          />
        )}
      </div>
    </div>
  );
}